import React, { useEffect, useRef, useState } from 'react';

import { Box, Grid, TextField, Typography } from '@material-ui/core';
import {
  Autocomplete,
  GoogleMap,
  Marker,
  useLoadScript,
} from '@react-google-maps/api';

import DestinyIcon from '../../../../assets/img/point-orange.png';
// import DestinyIcon from '../../../../assets/img/destiny.png';
import PointIcon from '../../../../assets/img/point-orange.png';
import FloatingButton from '../../../../components/FloatingButton';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import { AssistanceDetails } from '../../../../constants/assistance.constant';
import {
  DEFAULT_CENTER,
  ZOOM_DEFAULT,
} from '../../../../constants/maps.constant';
import { useAssistanceDataContext } from '../../../../context/assistance/assistance.provider';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';

const libraries: (
  | 'places'
  | 'drawing'
  | 'geometry'
  | 'localContext'
  | 'visualization'
)[] = ['places'];

const Transfer = () => {
  const { nextStep, assistance_body, updateAssistanceBody } =
    useAssistanceDataContext();
  const { assistance_detail } = assistance_body;
  const [origin, setOrigin] = useState<any>(null);
  const [destiny, setDestiny] = useState<any>(null);
  const { user } = useAuthDataContext();

  const CallNextStep = () => {
    dataLayerPush('asistencia_ubicación', user?.id);
    nextStep();
  };

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string, // ,
    libraries,
    language: 'es',
    region: 'ar',
  });
  const originRef = useRef<Autocomplete>(null);
  const destinyRef = useRef<Autocomplete>(null);

  const Geocoder = window?.google?.maps
    ? new window.google.maps.Geocoder()
    : undefined;

  useEffect(() => {
    if (assistance_body.pickup_location) {
      setOrigin({
        lat: assistance_body.pickup_location.latitude,
        lng: assistance_body.pickup_location.longitude,
      });
    }

    if (assistance_body.destiny_location) {
      setDestiny({
        lat: assistance_body.destiny_location.latitude,
        lng: assistance_body.destiny_location.longitude,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (Geocoder && !origin) {
      navigator.geolocation.getCurrentPosition(initializeOrigin, () => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Geocoder, origin]);

  const getBodyAddress = (place: any) => {
    const latitude = place?.geometry?.location.lat();
    const longitude = place?.geometry?.location.lng();
    const description = place.formatted_address;
    const street = place.address_components[0].long_name;
    const street_number = place.formatted_address.match(/(\d+)/)
      ? place.formatted_address.match(/(\d+)/)[0]
      : undefined;
    const country = place.address_components.find(
      (component: any) =>
        !!component.types.find((type: string) => type === 'country')
    )?.long_name;
    const province = place.address_components.find(
      (component: any) =>
        !!component.types.find(
          (type: string) => type === 'administrative_area_level_1'
        )
    )?.long_name;

    return {
      latitude,
      longitude,
      description,
      street,
      street_number,
      country,
      province,
    };
  };

  const initializeOrigin = (position: any) => {
    const latLng = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    };

    Geocoder?.geocode({ location: latLng }, (results: any, status: any) => {
      if (status === window.google.maps.GeocoderStatus.OK) {
        if (results.length) {
          updateAssistanceBody({
            pickup_location: getBodyAddress(results[0]),
          });
          setOrigin(latLng);
        } else {
          window.alert('No results found');
        }
      }
    });
  };

  const onOriginAutocompleteChange = () => {
    if (originRef !== null) {
      const place = originRef?.current?.state?.autocomplete?.getPlace();
      const lat = place?.geometry?.location.lat();
      const lng = place?.geometry?.location.lng();

      updateAssistanceBody({
        pickup_location: getBodyAddress(place),
      });
      setOrigin({ lat, lng });
    }
  };

  const onDestinyAutocompleteChange = () => {
    if (destinyRef !== null) {
      const place = destinyRef.current?.state?.autocomplete?.getPlace();
      const lat = place?.geometry?.location.lat();
      const lng = place?.geometry?.location.lng();

      updateAssistanceBody({
        destiny_location: getBodyAddress(place),
      });
      setDestiny({ lat, lng });
    }
  };

  return (
    <Grid container style={{ height: '100%' }}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <Box mr={4}>
          <Box my={4}>
            <Typography variant="h6">
              {assistance_detail === AssistanceDetails.VEHICLE_WONT_START ||
              assistance_detail === AssistanceDetails.SPARE_TIRE
                ? '¿Dónde se encuentra tu vehículo?'
                : '¿Dónde te vamos a buscar?'}
            </Typography>
          </Box>
          <Box my={4}>
            {isLoaded ? (
              <Box>
                <Autocomplete
                  ref={originRef}
                  onPlaceChanged={onOriginAutocompleteChange}
                >
                  <Box mb={2}>
                    <Typography variant="subtitle2"> Desde </Typography>
                    <TextField
                      size="small"
                      error={!origin}
                      helperText={!origin ? 'Debes ingresar tu ubicación' : ''}
                      name="origin"
                      fullWidth={true}
                      id="origin"
                      placeholder="Tu ubicación"
                      variant="outlined"
                      defaultValue={
                        assistance_body?.pickup_location?.description || ''
                      }
                    />
                  </Box>
                </Autocomplete>
                {assistance_detail !== AssistanceDetails.VEHICLE_WONT_START &&
                assistance_detail !== AssistanceDetails.SPARE_TIRE ? (
                  <Autocomplete
                    ref={destinyRef}
                    onPlaceChanged={onDestinyAutocompleteChange}
                  >
                    <Box mb={2}>
                      <Typography variant="subtitle2"> Hasta </Typography>
                      <TextField
                        size="small"
                        error={!destiny}
                        helperText={
                          !destiny
                            ? 'Debes ingresar la dirección a donde será llevado tu vehículo'
                            : ''
                        }
                        name="destiny"
                        fullWidth={true}
                        id="destiny"
                        placeholder="¿A dónde llevamos el vehículo?"
                        variant="outlined"
                        defaultValue={
                          assistance_body?.destiny_location?.description || ''
                        }
                      />
                    </Box>
                  </Autocomplete>
                ) : null}
              </Box>
            ) : null}
          </Box>
          <Box my={4}>
            <FloatingButton
              onClick={() => CallNextStep()}
              disabled={
                assistance_detail === AssistanceDetails.VEHICLE_WONT_START ||
                assistance_detail === AssistanceDetails.SPARE_TIRE
                  ? !origin
                  : !(origin && destiny)
              }
            >
              Continuar
            </FloatingButton>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} sm={6} md={8} lg={9}>
        <Box position="relative" width="100%" height="100%">
          <Box display={!isLoaded ? 'block' : 'none'}>
            <Loader action={'Cargando mapa'}></Loader>
          </Box>
          {isLoaded ? (
            <GoogleMap
              id="assitance-map"
              mapContainerStyle={{
                minHeight: '450px',
                height: '100%',
                width: '100%',
              }}
              center={destiny || origin ? destiny || origin : DEFAULT_CENTER}
              zoom={destiny && origin ? ZOOM_DEFAULT - 3 : ZOOM_DEFAULT}
            >
              {origin ? (
                <Marker
                  icon={PointIcon}
                  position={origin}
                  // label={"Desde"}
                  title={'Desde'}
                />
              ) : null}
              {destiny ? (
                <Marker icon={DestinyIcon} position={destiny} title={'Hasta'} />
              ) : null}
            </GoogleMap>
          ) : null}
        </Box>
      </Grid>
    </Grid>
  );
};

export default Transfer;
